import { translate } from "@/utils/langUtils";
import "./style.css";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Block, Inline } from "../../crRender";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const RedioBtns = ({ List = [], className = '', name, formHandler, label=null, isRequired = true ,defaultValue}) => {

  const { i18n } = useTranslation()
  const { formValues, handleFormValues } = formHandler


  const MappedList = useMemo(() => List.map((item) => ({
    label: translate(item?.label),
    value: item?.value
  })), [List, i18n?.language])


  return (
    <div className={`selector ${className} ${formValues[name]?.isError ? "field-required" : ""}`}>
      <Block isRender={name && !label} className="selector__title">
        {translate("Select all that apply") + " " + translate(name)}
        <Inline isRender={isRequired} className={"required"}>*</Inline>
      </Block>
      <Block isRender={label} className="selector__title">
        {translate(label)}
        <Inline isRender={isRequired} className={"required"}>*</Inline>
      </Block>
      <div className="row spec-selector">
        {MappedList.map((specialty) =>
          <div key={specialty?.value} onClick={() => handleFormValues(name, { value: specialty?.value, isRequired, isError: false })}
            className={`option ${(formValues[name]?.value ?? defaultValue) === specialty?.value ? "option--active" : ""} col-lg-4 col-md-6 col-sm-12 `} >
            <div className={`option__check ${(formValues[name]?.value ?? defaultValue) === specialty?.value ? "selected" : ""}`}>
              <Icon className="check-true-icon" icon={"lets-icons:check-fill"} />
            </div>
            <div className="option__text">{specialty?.label}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RedioBtns;

